import { ResponsiveImageType } from "react-datocms";
import { Section, Container, ImageWithText, EyeIcon, AlertIcon, ZoomFaceIcon, LightningBoltIcon } from "@/components";
import { HorizontalRule } from "@narrative-software/narrative-web-ui";
import LightroomImportIcon from "../icons/LightroomImportIcon";

type VideoFields = {
  mp4Url: string;
  thumbnailUrl: string;
  width: number;
  height: number;
};

const productFeaturesSectionFields = `
  title
  productFeatures {
    icon
    title
    description
    videoOrImage {
      responsiveImage {
        ...responsiveImageFragment
      }
      video {
        mp4Url
        thumbnailUrl
        width
        height
      }
    }
    afterMarginClasses
  }
`;

const iconMap = {
  "Lightning bolt": <LightningBoltIcon />,
  Eye: <EyeIcon />,
  "Hexagon with exclamation mark": <AlertIcon />,
  "Person with magnifying glass": <ZoomFaceIcon />,
  "Ship to lightroom": <LightroomImportIcon />,
} as const;

type ProductFeature = {
  icon: keyof typeof iconMap;
  title: string;
  description: string;
  afterMarginClasses?: string;
  videoOrImage: {
    responsiveImage: ResponsiveImageType;
    video: {
      mp4Url: string;
      thumbnailUrl: string;
      width: number;
      height: number;
    };
  };
};

type ProductFeaturesProps = {
  title: string;
  productFeatures: ProductFeature[];
};

const ProductFeatures = ({ title, productFeatures }: ProductFeaturesProps) => {
  return (
    <Section>
      <Container>
        <HorizontalRule bottomMargin />
        <h2 className="text-h2 font-semibold leading-compact mb-10 lg:mb-16 text-center">{title}</h2>

        {productFeatures?.map(({ title, description, icon, videoOrImage, afterMarginClasses }, index) => (
          <ImageWithText
            key={title}
            title={title}
            datoVideoOrImage={videoOrImage}
            orientation={index % 2 === 0 ? "image-left" : "image-right"}
            className={afterMarginClasses || (index === productFeatures.length - 1 ? "" : "mb-10 md:mb-18")}
            icon={iconMap[icon]}
          >
            {description}
          </ImageWithText>
        ))}
      </Container>
    </Section>
  );
};

export type { ProductFeature, VideoFields };
export { ProductFeatures, productFeaturesSectionFields };
